import { ReactComponent as Logo } from '../../../../assets/apropologo.svg';
import React, {
  useCallback,
} from "react";

const MenuBottomLogo = ({ colorFiltre, isFiltred }) => {

      // ✅ Handler mémoïsé pour Street View
      const gotoApropo = useCallback(() => {
       
          window.open("https://apropo-lessables.com/", "_blank", "noopener,noreferrer");
        
      }, []);

    return (
        <div
            className="menu-bottom-logo"
            style={{
                '--logo-color': "var(--colorFront)",
            }}
            onClick={gotoApropo}
        >
            <Logo
                className="logo-icon"
                alt="Apropo"
            />
        </div>
    )
};

export default MenuBottomLogo;

/*
    return (
        <div
            className="menu-bottom-logo"
            style={{
                '--logo-color': !isFiltred ? "var(--colorBack)" : colorFiltre,
            }}
        >
            <Logo
                className="logo-icon"
                alt="Apropo"
            />
        </div>
    )
        */


